import React from 'react';

import FiltersRefinementContentItem from '../FiltersRefinementContentItem';

import {IFiltersRefinementContentTextProps} from './IFiltersRefinementContentText';

import filterContentStyles from '../../FiltersRefinementContent.module.scss';

const FiltersRefinementContentText = ({refinement}: IFiltersRefinementContentTextProps) => {
	if (!refinement) {
		return null;
	}

	const classNames = {
		checkbox: filterContentStyles['filter-refinements__checkbox'],
		label: filterContentStyles['filter-refinements__label'],
	};

	return refinement.getValues().map((refinementValue) => {

		return (
			<FiltersRefinementContentItem
				key={refinementValue.getKey()}
				refinementValue={refinementValue}
				classNames={classNames}
			/>
		);
	});
};

export default FiltersRefinementContentText;